import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { AssociatedDocumentEditionListStore } from "../../store/AssociatedDocumentEditionListStore";

type AssociatedDocumentEditionListDialogsProps = {
  store: AssociatedDocumentEditionListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de AssociatedDocumentEdition.
 * Separado para mantener AssociatedDocumentEditionListPage más limpio.
 */
export const AssociatedDocumentEditionListDialogs: React.FC<AssociatedDocumentEditionListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
